module.exports = __webpack_public_path__ + "img/icon-plugin-configure.0ec70bb8.svg";